package pl.decks.chartjs.model

sealed class JSScriptable<T> {
    data class Static<T>(val value: T) : JSScriptable<T>()
    data class Scriptable<T>(val fn: (dynamic) -> T) : JSScriptable<T>()
    data class TypedScriptable<C, T>(val fn: (C) -> T) : JSScriptable<T>()

    internal fun toChartJs(transform: (T) -> dynamic): dynamic =
        when (this) {
            is Static -> transform(value)
            is Scriptable -> fn.asDynamic()
            is TypedScriptable<*, T> -> fn.asDynamic()
        }

}
